import React, {Fragment} from "react";
import StepQuestion from "components/Step/StepQuestion";
import * as ValidationRule from "utils/ValidationRule";
import {Input} from "reactstrap";
import StepFeedback from "components/Step/StepFeedback";
import ValidationMethods from "utils/ValidationMethods";
import StepButton from "components/Step/StepButton";
import StepInputLabel from "components/Step/StepInputLabel";

const fieldKey = "email";
const fieldConfirmationKey = "emailConfirmation";
const emailAddressMustMatch = "Email addresses must match";

export default class EmailCaptureStep extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.verb = this.props.value && this.props.value.length > 0 ? "confirm" : "enter";

        let validations = [{
            field: fieldKey,
            value: this.props.value,
            yupRule: ValidationRule.getEmailAddressRule("Email Address", this.props.required)
        }];

        let errors = ValidationMethods.validateInitial(this, validations, true);

        if (errors.email !== undefined && errors.email.length === 0) {
            if (this.props.required === false) {
                delete errors.email;
            }
        }

        this.state = {
            errors: errors,
            emailAddress: "",
            confirmationError: this.props[fieldConfirmationKey] !== undefined && this.props[fieldConfirmationKey] !== this.props.value ? emailAddressMustMatch : ""
        }
    }

    onChange(e) {
        let value = e.target.value;
        ValidationMethods.validateOnChange(this, fieldKey, value);

        if (this.props.onChange) {
            this.props.onChange(value);
        }

        this.setState({
            emailAddress: e.target.value
        });
    }

    onConfirmationChange(e) {
        let confirmationValue = e.target.value;
        let confirmationError = undefined;
        if (this.state.emailAddress !== confirmationValue) {
            confirmationError = "Email addresses must match";
        }

        if (this.props.onChange) {
            this.props.onKeyValueChange(fieldConfirmationKey, confirmationValue);
        }

        this.setState({
            confirmationValue: e.target.value,
            confirmationError: confirmationError
        });
    }

    isInvalid(key) {
        return this.state.errors[key] !== undefined && this.state.errors[key].length > 0
    }

    render() {
        let text = "Please " + this.verb + " your email address.";
        let label = "Email Address";
        let confirmLabel = "Confirm Email Address";
        let placeholder = "eg. example@example.com";
        let information = "We'll let you know when your money arrives.";
        if (!this.props.required) {
            label = "Email Address (optional)";
            confirmLabel = "Confirm Email Address";
        }

        return <Fragment>
            <StepQuestion>{text}</StepQuestion>
            <StepQuestion>
                {information}
            </StepQuestion>
            <StepInputLabel>{label}</StepInputLabel>
            <Input
                id={fieldKey}
                type={"text"}
                placeholder={placeholder}
                value={this.props.value}
                onChange={this.onChange.bind(this)}
                invalid={this.isInvalid(fieldKey)}
            />
            <StepFeedback>{this.state.errors.email}</StepFeedback>

            <StepInputLabel>{confirmLabel}</StepInputLabel>
            <Input
                id={"emailConfirmation"}
                type={"text"}
                placeholder={placeholder}
                value={this.props[fieldConfirmationKey]}
                onChange={this.onConfirmationChange.bind(this)}
                invalid={this.state.confirmationError !== undefined && this.state.confirmationError.length > 0}
            />
            <StepFeedback>{this.state.confirmationError}</StepFeedback>

            <StepButton
                disabled={Object.keys(this.state.errors).length > 0 || this.state.emailAddress !== (this.props[fieldConfirmationKey] || "")}
                onClick={this.props.onNextClick}
            >
                Next
            </StepButton>
            <StepButton
                color={"secondary"}
                onClick={this.props.onBackClick}
            >
                Back
            </StepButton>
        </Fragment>
    }
}